"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonsSetSize = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var ButtonsSetSize;
(function (ButtonsSetSize) {
    ButtonsSetSize["Medium"] = "medium";
    ButtonsSetSize["Small"] = "small";
})(ButtonsSetSize || (exports.ButtonsSetSize = ButtonsSetSize = {}));
const ButtonsSet = react_1.default.memo(({ size = ButtonsSetSize.Medium, children }) => ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(styles_module_css_1.default.buttons, styles_module_css_1.default[size]), children: children })));
exports.default = ButtonsSet;
